"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asBodilessImage = exports.withImagePlaceholder = exports.DropZonePlugin = void 0;

var react_1 = __importStar(require("react"));

var debug_1 = __importDefault(require("debug"));

var core_1 = require("@bodiless/core");

var react_dropzone_1 = require("react-dropzone");

var BackendSave_1 = __importDefault(require("./BackendSave"));

var withPropsFromPlaceholder_1 = __importDefault(require("./withPropsFromPlaceholder")); // @ts-ignore fails when it is imported by jest.


var placeholder_png_1 = __importDefault(require("./placeholder.png")); // Controls the time spent on file upload


var MaxTimeout = 10000;
var errorLog = debug_1.default('Image');
var defaultImagePickerUI = {
  MasterWrapper: 'section',
  Wrapper: 'div',
  Input: 'input',
  UploadArea: function UploadArea() {
    return react_1.default.createElement("div", null, "Drag a file or click here to upload.");
  },
  Uploading: function Uploading() {
    return react_1.default.createElement("div", null, "Upload is in progress");
  },
  DragRejected: function DragRejected() {
    return react_1.default.createElement("div", null, "File type not accepted or too many, try again!");
  },
  UploadTimeout: function UploadTimeout() {
    return react_1.default.createElement("div", null, "Upload failed, please try again.");
  },
  UploadFinished: function UploadFinished() {
    return react_1.default.createElement("div", null, "Done!");
  },
  UploadStatus: function UploadStatus(_a) {
    var statusText = _a.statusText;
    return react_1.default.createElement("div", null, statusText);
  }
}; // DropZonePlugin control the upload of file and only saves jpg/png files.

function DropZonePlugin(_a) {
  var formApi = _a.formApi,
      targetFieldName = _a.targetFieldName,
      ui = _a.ui;

  var _b = react_1.useState(''),
      statusText = _b[0],
      setStatusText = _b[1];

  var _c = react_1.useState(false),
      isUploading = _c[0],
      setIsUploading = _c[1];

  var _d = react_1.useState(false),
      isUploadTimeout = _d[0],
      setIsUploadingTimeout = _d[1];

  var _e = react_1.useState(false),
      isUploadFinished = _e[0],
      setIsUploadFinished = _e[1];

  var saveRequest = new BackendSave_1.default();
  var node = core_1.useNode().node;
  react_1.useEffect(function () {
    if (isUploading) {
      var timer_1 = setTimeout(function () {
        if (isUploading) {
          saveRequest.cancel('Timeout exceeded');
          formApi.setError(targetFieldName, 'Timeout exceeded');
          setIsUploadingTimeout(true);
          setIsUploading(false);
        }
      }, MaxTimeout);
      return function () {
        return clearTimeout(timer_1);
      };
    }

    return function () {
      return null;
    };
  });
  var onDrop = react_1.useCallback(function (acceptedFiles) {
    // When files are rejected by the react-dropzone,
    // acceptedFiles is an empty array.
    if (acceptedFiles.length < 1) {
      setStatusText('File type not accepted or too many, try again!');
      console.error('Unable to upload selected files.', acceptedFiles);
      return;
    }

    setIsUploading(true);
    setIsUploadFinished(false);
    setIsUploadingTimeout(false);
    setStatusText("File \"" + acceptedFiles[0].name + "\" selected");
    formApi.setError(targetFieldName, 'Uploading in progress');
    saveRequest.saveFile({
      file: acceptedFiles[0],
      nodePath: node.path.join('$'),
      baseResourcePath: node.baseResourcePath
    }).then(function (_a) {
      var data = _a.data; // unset errors

      formApi.setError(targetFieldName, undefined);
      formApi.setValue(targetFieldName, data.filesPath[0]); // formApi.validate();

      setIsUploading(false);
      setIsUploadingTimeout(false);
      setIsUploadFinished(true);
    }).catch(errorLog);
  }, []);

  var _f = react_dropzone_1.useDropzone({
    onDrop: onDrop,
    accept: 'image/jpeg, image/png, image/svg+xml, image/gif, image/apng',
    multiple: false
  }),
      getRootProps = _f.getRootProps,
      getInputProps = _f.getInputProps,
      isDragReject = _f.isDragReject;

  var _g = __assign(__assign({}, defaultImagePickerUI), ui),
      MasterWrapper = _g.MasterWrapper,
      Wrapper = _g.Wrapper,
      Input = _g.Input,
      UploadArea = _g.UploadArea,
      Uploading = _g.Uploading,
      DragRejected = _g.DragRejected,
      UploadTimeout = _g.UploadTimeout,
      UploadFinished = _g.UploadFinished,
      UploadStatus = _g.UploadStatus;

  return react_1.default.createElement(MasterWrapper, null, react_1.default.createElement(Wrapper, __assign({}, getRootProps()), react_1.default.createElement(Input, __assign({}, getInputProps())), react_1.default.createElement(UploadArea, null), isDragReject && react_1.default.createElement(DragRejected, null), isUploadTimeout && react_1.default.createElement(UploadTimeout, null), isUploading && react_1.default.createElement(Uploading, null), isUploadFinished && react_1.default.createElement(UploadFinished, null), react_1.default.createElement(UploadStatus, {
    statusText: statusText
  })));
}

exports.DropZonePlugin = DropZonePlugin;
DropZonePlugin.defaultProps = {
  ui: {}
}; // Options used to create an edit button.

var options = {
  icon: 'image',
  label: 'Select',
  groupLabel: 'Image',
  formTitle: 'Image',
  name: 'Image',
  renderForm: function renderForm(_a) {
    var formUi = _a.ui,
        formApi = _a.formApi,
        componentProps = _a.componentProps;
    var imagePickerUI = componentProps.ui;

    var _b = core_1.getUI(formUi),
        ComponentFormLabel = _b.ComponentFormLabel,
        ComponentFormText = _b.ComponentFormText;

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ComponentFormLabel, {
      htmlFor: "image-src"
    }, "Src"), react_1.default.createElement(ComponentFormText, {
      field: "src",
      id: "image-src"
    }), react_1.default.createElement(ComponentFormLabel, {
      htmlFor: "image-alt"
    }, "Alt"), react_1.default.createElement(ComponentFormText, {
      field: "alt",
      id: "image-alt"
    }), react_1.default.createElement(DropZonePlugin, {
      formApi: formApi,
      targetFieldName: "src",
      ui: imagePickerUI
    }));
  },
  global: false,
  local: true,
  defaultData: {
    src: placeholder_png_1.default,
    alt: 'Alt Text'
  }
};
exports.withImagePlaceholder = withPropsFromPlaceholder_1.default(['src']);
exports.asBodilessImage = core_1.asBodilessComponent(options);
var Image = exports.asBodilessImage()('img');
exports.default = Image;